import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';

import { PipesModule } from '@shure/cloud/shared/ui/pipes';
import {
	BooleanValueAccessor,
	PrismButtonComponent,
	PrismCheckboxComponent,
	PrismDialogComponent,
	PrismIconComponent,
	PrismInputComponent,
	PrismMenuComponent,
	PrismMenuItemComponent,
	PrismSelectComponent,
	TextValueAccessor
} from '@shure/prism-angular-components';

import { ShProgressiveProfileDialogComponent } from './progressive-profile-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		MatCardModule,
		MatButtonModule,
		MatIconModule,
		TranslocoModule,
		MatListModule,
		PipesModule,
		NgxMaskDirective,
		MatFormFieldModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatSelectModule,
		MatCheckboxModule,
		MatInputModule,
		PrismInputComponent,
		PrismSelectComponent,
		PrismCheckboxComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		PrismDialogComponent,
		PrismIconComponent,
		PrismButtonComponent,
		TextValueAccessor,
		BooleanValueAccessor
	],
	providers: [provideEnvironmentNgxMask()],
	declarations: [ShProgressiveProfileDialogComponent],
	exports: [ShProgressiveProfileDialogComponent]
})
export class ShProgressiveProfileDialogModule {}
